/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.5.0 (NJsonSchema v10.6.6.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { BaseClientApi, ClientApiConfig } from '@eta/components';
import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export interface IComplaintManagmentClient {
    /**
     * @param body (optional) 
     * @return Success
     */
    submitComplaint(body?: SubmitComplaintRequest | undefined): Promise<SubmitComplaintResult>;
    /**
     * @param id (optional) 
     * @param reportId (optional) 
     * @param creationDateFrom (optional) 
     * @param creationDateTo (optional) 
     * @param category (optional) 
     * @param type (optional) 
     * @param status (optional) 
     * @param title (optional) 
     * @param receiverRIN (optional) 
     * @param sellerRIN (optional) 
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @param orderByDirection (optional) 
     * @param orderByExpression (optional) 
     * @return Success
     */
    getComplaints(id?: number | undefined, reportId?: string | undefined, creationDateFrom?: Date | undefined, creationDateTo?: Date | undefined, category?: ComplaintCategories | undefined, type?: ComplaintTypes | undefined, status?: ComplaintStatuses | undefined, title?: string | undefined, receiverRIN?: string | undefined, sellerRIN?: string | undefined, pageSize?: number | undefined, pageNumber?: number | undefined, orderByDirection?: OrderByDirections | undefined, orderByExpression?: ComplaintsOrderByExpressions | undefined): Promise<GetComplaintsResult>;
    /**
     * @return Success
     */
    getComplaintDetails(id: number): Promise<GetComplaintDetails>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateComplaint(id: number, body?: UpdateComplaintRequest | undefined): Promise<UpdateComplaintResult>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateComplaintStatus(id: number, body?: UpdateStatusRequest | undefined): Promise<UpdateStatusResult>;
    /**
     * @return Success
     */
    getComplaintLookups(): Promise<ComplaintLookupsResult>;
    /**
     * @param body (optional) 
     * @return Success
     */
    submitFrauds(body?: SubmitFraudRequest | undefined): Promise<SubmitFraudResult>;
    /**
     * @param id (optional) 
     * @param reportId (optional) 
     * @param creationDateFrom (optional) 
     * @param creationDateTo (optional) 
     * @param type (optional) 
     * @param status (optional) 
     * @param title (optional) 
     * @param receiptUUID (optional) 
     * @param sellerRIN (optional) 
     * @param mobileNumber (optional) 
     * @param idNumber (optional) 
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @param orderByDirection (optional) 
     * @param orderByExpression (optional) 
     * @return Success
     */
    getFrauds(id?: number | undefined, reportId?: string | undefined, creationDateFrom?: Date | undefined, creationDateTo?: Date | undefined, type?: FraudTypes | undefined, status?: FraudStatuses | undefined, title?: string | undefined, receiptUUID?: string | undefined, sellerRIN?: string | undefined, mobileNumber?: string | undefined, idNumber?: string | undefined, pageSize?: number | undefined, pageNumber?: number | undefined, orderByDirection?: OrderByDirections | undefined, orderByExpression?: FraudsOrderByExpressions | undefined): Promise<GetFraudsResult>;
    /**
     * @param reportId (optional) 
     * @param mobileNumber (optional) 
     * @param idNumber (optional) 
     * @return Success
     */
    viewFraudReportAnonymously(reportId?: string | undefined, mobileNumber?: string | undefined, idNumber?: string | undefined): Promise<ViewFraudResponse>;
    /**
     * @return Success
     */
    getFraudDetails(id: number): Promise<GetFraudDetails>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateFraud(id: number, body?: UpdateFraudRequest | undefined): Promise<UpdateFraudResult>;
    /**
     * @return Success
     */
    getFraudLookups(): Promise<FraudLookupsResult>;
}

export class ComplaintManagmentClient extends BaseClientApi implements IComplaintManagmentClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ClientApiConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    submitComplaint(body?: SubmitComplaintRequest | undefined , cancelToken?: CancelToken | undefined): Promise<SubmitComplaintResult> {
        let url_ = this.baseUrl + "/api/v{version}/Complaints";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmitComplaint(_response);
        });
    }

    protected processSubmitComplaint(response: AxiosResponse): Promise<SubmitComplaintResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SubmitComplaintResult.fromJS(resultData200);
            return Promise.resolve<SubmitComplaintResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SubmitComplaintResult>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param reportId (optional) 
     * @param creationDateFrom (optional) 
     * @param creationDateTo (optional) 
     * @param category (optional) 
     * @param type (optional) 
     * @param status (optional) 
     * @param title (optional) 
     * @param receiverRIN (optional) 
     * @param sellerRIN (optional) 
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @param orderByDirection (optional) 
     * @param orderByExpression (optional) 
     * @return Success
     */
    getComplaints(id?: number | undefined, reportId?: string | undefined, creationDateFrom?: Date | undefined, creationDateTo?: Date | undefined, category?: ComplaintCategories | undefined, type?: ComplaintTypes | undefined, status?: ComplaintStatuses | undefined, title?: string | undefined, receiverRIN?: string | undefined, sellerRIN?: string | undefined, pageSize?: number | undefined, pageNumber?: number | undefined, orderByDirection?: OrderByDirections | undefined, orderByExpression?: ComplaintsOrderByExpressions | undefined , cancelToken?: CancelToken | undefined): Promise<GetComplaintsResult> {
        let url_ = this.baseUrl + "/api/v{version}/Complaints?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "ReportId=" + encodeURIComponent("" + reportId) + "&";
        if (creationDateFrom === null)
            throw new Error("The parameter 'creationDateFrom' cannot be null.");
        else if (creationDateFrom !== undefined)
            url_ += "CreationDateFrom=" + encodeURIComponent(creationDateFrom ? "" + creationDateFrom.toJSON() : "") + "&";
        if (creationDateTo === null)
            throw new Error("The parameter 'creationDateTo' cannot be null.");
        else if (creationDateTo !== undefined)
            url_ += "CreationDateTo=" + encodeURIComponent(creationDateTo ? "" + creationDateTo.toJSON() : "") + "&";
        if (category === null)
            throw new Error("The parameter 'category' cannot be null.");
        else if (category !== undefined)
            url_ += "Category=" + encodeURIComponent("" + category) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (title === null)
            throw new Error("The parameter 'title' cannot be null.");
        else if (title !== undefined)
            url_ += "Title=" + encodeURIComponent("" + title) + "&";
        if (receiverRIN === null)
            throw new Error("The parameter 'receiverRIN' cannot be null.");
        else if (receiverRIN !== undefined)
            url_ += "ReceiverRIN=" + encodeURIComponent("" + receiverRIN) + "&";
        if (sellerRIN === null)
            throw new Error("The parameter 'sellerRIN' cannot be null.");
        else if (sellerRIN !== undefined)
            url_ += "SellerRIN=" + encodeURIComponent("" + sellerRIN) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (orderByDirection === null)
            throw new Error("The parameter 'orderByDirection' cannot be null.");
        else if (orderByDirection !== undefined)
            url_ += "OrderByDirection=" + encodeURIComponent("" + orderByDirection) + "&";
        if (orderByExpression === null)
            throw new Error("The parameter 'orderByExpression' cannot be null.");
        else if (orderByExpression !== undefined)
            url_ += "OrderByExpression=" + encodeURIComponent("" + orderByExpression) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetComplaints(_response);
        });
    }

    protected processGetComplaints(response: AxiosResponse): Promise<GetComplaintsResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetComplaintsResult.fromJS(resultData200);
            return Promise.resolve<GetComplaintsResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetComplaintsResult>(<any>null);
    }

    /**
     * @return Success
     */
    getComplaintDetails(id: number , cancelToken?: CancelToken | undefined): Promise<GetComplaintDetails> {
        let url_ = this.baseUrl + "/api/v{version}/Complaints/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetComplaintDetails(_response);
        });
    }

    protected processGetComplaintDetails(response: AxiosResponse): Promise<GetComplaintDetails> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetComplaintDetails.fromJS(resultData200);
            return Promise.resolve<GetComplaintDetails>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetComplaintDetails>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateComplaint(id: number, body?: UpdateComplaintRequest | undefined , cancelToken?: CancelToken | undefined): Promise<UpdateComplaintResult> {
        let url_ = this.baseUrl + "/api/v{version}/Complaints/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateComplaint(_response);
        });
    }

    protected processUpdateComplaint(response: AxiosResponse): Promise<UpdateComplaintResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateComplaintResult.fromJS(resultData200);
            return Promise.resolve<UpdateComplaintResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateComplaintResult>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateComplaintStatus(id: number, body?: UpdateStatusRequest | undefined , cancelToken?: CancelToken | undefined): Promise<UpdateStatusResult> {
        let url_ = this.baseUrl + "/api/v{version}/Complaints/{id}/state";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateComplaintStatus(_response);
        });
    }

    protected processUpdateComplaintStatus(response: AxiosResponse): Promise<UpdateStatusResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateStatusResult.fromJS(resultData200);
            return Promise.resolve<UpdateStatusResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateStatusResult>(<any>null);
    }

    /**
     * @return Success
     */
    getComplaintLookups(  cancelToken?: CancelToken | undefined): Promise<ComplaintLookupsResult> {
        let url_ = this.baseUrl + "/api/v{version}/Complaints/lookups";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetComplaintLookups(_response);
        });
    }

    protected processGetComplaintLookups(response: AxiosResponse): Promise<ComplaintLookupsResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ComplaintLookupsResult.fromJS(resultData200);
            return Promise.resolve<ComplaintLookupsResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ComplaintLookupsResult>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    submitFrauds(body?: SubmitFraudRequest | undefined , cancelToken?: CancelToken | undefined): Promise<SubmitFraudResult> {
        let url_ = this.baseUrl + "/api/v{version}/Frauds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmitFrauds(_response);
        });
    }

    protected processSubmitFrauds(response: AxiosResponse): Promise<SubmitFraudResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SubmitFraudResult.fromJS(resultData200);
            return Promise.resolve<SubmitFraudResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SubmitFraudResult>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param reportId (optional) 
     * @param creationDateFrom (optional) 
     * @param creationDateTo (optional) 
     * @param type (optional) 
     * @param status (optional) 
     * @param title (optional) 
     * @param receiptUUID (optional) 
     * @param sellerRIN (optional) 
     * @param mobileNumber (optional) 
     * @param idNumber (optional) 
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @param orderByDirection (optional) 
     * @param orderByExpression (optional) 
     * @return Success
     */
    getFrauds(id?: number | undefined, reportId?: string | undefined, creationDateFrom?: Date | undefined, creationDateTo?: Date | undefined, type?: FraudTypes | undefined, status?: FraudStatuses | undefined, title?: string | undefined, receiptUUID?: string | undefined, sellerRIN?: string | undefined, mobileNumber?: string | undefined, idNumber?: string | undefined, pageSize?: number | undefined, pageNumber?: number | undefined, orderByDirection?: OrderByDirections | undefined, orderByExpression?: FraudsOrderByExpressions | undefined , cancelToken?: CancelToken | undefined): Promise<GetFraudsResult> {
        let url_ = this.baseUrl + "/api/v{version}/Frauds?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "ReportId=" + encodeURIComponent("" + reportId) + "&";
        if (creationDateFrom === null)
            throw new Error("The parameter 'creationDateFrom' cannot be null.");
        else if (creationDateFrom !== undefined)
            url_ += "CreationDateFrom=" + encodeURIComponent(creationDateFrom ? "" + creationDateFrom.toJSON() : "") + "&";
        if (creationDateTo === null)
            throw new Error("The parameter 'creationDateTo' cannot be null.");
        else if (creationDateTo !== undefined)
            url_ += "CreationDateTo=" + encodeURIComponent(creationDateTo ? "" + creationDateTo.toJSON() : "") + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (title === null)
            throw new Error("The parameter 'title' cannot be null.");
        else if (title !== undefined)
            url_ += "Title=" + encodeURIComponent("" + title) + "&";
        if (receiptUUID === null)
            throw new Error("The parameter 'receiptUUID' cannot be null.");
        else if (receiptUUID !== undefined)
            url_ += "ReceiptUUID=" + encodeURIComponent("" + receiptUUID) + "&";
        if (sellerRIN === null)
            throw new Error("The parameter 'sellerRIN' cannot be null.");
        else if (sellerRIN !== undefined)
            url_ += "SellerRIN=" + encodeURIComponent("" + sellerRIN) + "&";
        if (mobileNumber === null)
            throw new Error("The parameter 'mobileNumber' cannot be null.");
        else if (mobileNumber !== undefined)
            url_ += "MobileNumber=" + encodeURIComponent("" + mobileNumber) + "&";
        if (idNumber === null)
            throw new Error("The parameter 'idNumber' cannot be null.");
        else if (idNumber !== undefined)
            url_ += "IdNumber=" + encodeURIComponent("" + idNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (orderByDirection === null)
            throw new Error("The parameter 'orderByDirection' cannot be null.");
        else if (orderByDirection !== undefined)
            url_ += "OrderByDirection=" + encodeURIComponent("" + orderByDirection) + "&";
        if (orderByExpression === null)
            throw new Error("The parameter 'orderByExpression' cannot be null.");
        else if (orderByExpression !== undefined)
            url_ += "OrderByExpression=" + encodeURIComponent("" + orderByExpression) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFrauds(_response);
        });
    }

    protected processGetFrauds(response: AxiosResponse): Promise<GetFraudsResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetFraudsResult.fromJS(resultData200);
            return Promise.resolve<GetFraudsResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetFraudsResult>(<any>null);
    }

    /**
     * @param reportId (optional) 
     * @param mobileNumber (optional) 
     * @param idNumber (optional) 
     * @return Success
     */
    viewFraudReportAnonymously(reportId?: string | undefined, mobileNumber?: string | undefined, idNumber?: string | undefined , cancelToken?: CancelToken | undefined): Promise<ViewFraudResponse> {
        let url_ = this.baseUrl + "/api/v{version}/Frauds/report?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "ReportId=" + encodeURIComponent("" + reportId) + "&";
        if (mobileNumber === null)
            throw new Error("The parameter 'mobileNumber' cannot be null.");
        else if (mobileNumber !== undefined)
            url_ += "MobileNumber=" + encodeURIComponent("" + mobileNumber) + "&";
        if (idNumber === null)
            throw new Error("The parameter 'idNumber' cannot be null.");
        else if (idNumber !== undefined)
            url_ += "IdNumber=" + encodeURIComponent("" + idNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processViewFraudReportAnonymously(_response);
        });
    }

    protected processViewFraudReportAnonymously(response: AxiosResponse): Promise<ViewFraudResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ViewFraudResponse.fromJS(resultData200);
            return Promise.resolve<ViewFraudResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ViewFraudResponse>(<any>null);
    }

    /**
     * @return Success
     */
    getFraudDetails(id: number , cancelToken?: CancelToken | undefined): Promise<GetFraudDetails> {
        let url_ = this.baseUrl + "/api/v{version}/Frauds/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFraudDetails(_response);
        });
    }

    protected processGetFraudDetails(response: AxiosResponse): Promise<GetFraudDetails> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetFraudDetails.fromJS(resultData200);
            return Promise.resolve<GetFraudDetails>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetFraudDetails>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateFraud(id: number, body?: UpdateFraudRequest | undefined , cancelToken?: CancelToken | undefined): Promise<UpdateFraudResult> {
        let url_ = this.baseUrl + "/api/v{version}/Frauds/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateFraud(_response);
        });
    }

    protected processUpdateFraud(response: AxiosResponse): Promise<UpdateFraudResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateFraudResult.fromJS(resultData200);
            return Promise.resolve<UpdateFraudResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateFraudResult>(<any>null);
    }

    /**
     * @return Success
     */
    getFraudLookups(  cancelToken?: CancelToken | undefined): Promise<FraudLookupsResult> {
        let url_ = this.baseUrl + "/api/v{version}/Frauds/lookups";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFraudLookups(_response);
        });
    }

    protected processGetFraudLookups(response: AxiosResponse): Promise<FraudLookupsResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FraudLookupsResult.fromJS(resultData200);
            return Promise.resolve<FraudLookupsResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FraudLookupsResult>(<any>null);
    }
}

export enum AttachmentExtenssions {
    JPG = "JPG",
    PNG = "PNG",
}

export enum ComplaintCategories {
    Receipt = "Receipt",
    Submission = "Submission",
    POS = "POS",
    Other = "Other",
}

export class ComplaintLookupsResult implements IComplaintLookupsResult {
    categories?: LookupDto[] | undefined;
    types?: LookupDto[] | undefined;
    statuses?: LookupDto[] | undefined;
    header?: ResponseHeader;

    constructor(data?: IComplaintLookupsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(LookupDto.fromJS(item));
            }
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types!.push(LookupDto.fromJS(item));
            }
            if (Array.isArray(_data["statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["statuses"])
                    this.statuses!.push(LookupDto.fromJS(item));
            }
            this.header = _data["header"] ? ResponseHeader.fromJS(_data["header"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ComplaintLookupsResult {
        data = typeof data === 'object' ? data : {};
        let result = new ComplaintLookupsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item.toJSON());
        }
        if (Array.isArray(this.statuses)) {
            data["statuses"] = [];
            for (let item of this.statuses)
                data["statuses"].push(item.toJSON());
        }
        data["header"] = this.header ? this.header.toJSON() : <any>undefined;
        return data;
    }

    clone(): ComplaintLookupsResult {
        const json = this.toJSON();
        let result = new ComplaintLookupsResult();
        result.init(json);
        return result;
    }
}

export interface IComplaintLookupsResult {
    categories?: LookupDto[] | undefined;
    types?: LookupDto[] | undefined;
    statuses?: LookupDto[] | undefined;
    header?: ResponseHeader;
}

export enum ComplaintsOrderByExpressions {
    CreationDatetime = "CreationDatetime",
    Category = "Category",
    Type = "Type",
    Status = "Status",
}

export class ComplaintsResult implements IComplaintsResult {
    id?: number;
    reportId?: string | undefined;
    category?: string | undefined;
    type?: string | undefined;
    status?: string | undefined;
    title?: string | undefined;
    receiverRIN?: string | undefined;
    sellerRIN?: string | undefined;
    complainantFirstName?: string | undefined;
    complainantLastName?: string | undefined;
    complainantPhone?: string | undefined;
    reason?: string | undefined;
    response?: string | undefined;
    receipts?: ReceiptDto[] | undefined;
    submissions?: SubmissionDto[] | undefined;
    pos?: PosDto[] | undefined;
    createdBy?: string | undefined;
    creationDatetimeUtc?: Date;
    modifiedBy?: string | undefined;
    modificationDatetimeUtc?: Date | undefined;

    constructor(data?: IComplaintsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.reportId = _data["reportId"];
            this.category = _data["category"];
            this.type = _data["type"];
            this.status = _data["status"];
            this.title = _data["title"];
            this.receiverRIN = _data["receiverRIN"];
            this.sellerRIN = _data["sellerRIN"];
            this.complainantFirstName = _data["complainantFirstName"];
            this.complainantLastName = _data["complainantLastName"];
            this.complainantPhone = _data["complainantPhone"];
            this.reason = _data["reason"];
            this.response = _data["response"];
            if (Array.isArray(_data["receipts"])) {
                this.receipts = [] as any;
                for (let item of _data["receipts"])
                    this.receipts!.push(ReceiptDto.fromJS(item));
            }
            if (Array.isArray(_data["submissions"])) {
                this.submissions = [] as any;
                for (let item of _data["submissions"])
                    this.submissions!.push(SubmissionDto.fromJS(item));
            }
            if (Array.isArray(_data["pos"])) {
                this.pos = [] as any;
                for (let item of _data["pos"])
                    this.pos!.push(PosDto.fromJS(item));
            }
            this.createdBy = _data["createdBy"];
            this.creationDatetimeUtc = _data["creationDatetimeUtc"] ? new Date(_data["creationDatetimeUtc"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modificationDatetimeUtc = _data["modificationDatetimeUtc"] ? new Date(_data["modificationDatetimeUtc"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ComplaintsResult {
        data = typeof data === 'object' ? data : {};
        let result = new ComplaintsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reportId"] = this.reportId;
        data["category"] = this.category;
        data["type"] = this.type;
        data["status"] = this.status;
        data["title"] = this.title;
        data["receiverRIN"] = this.receiverRIN;
        data["sellerRIN"] = this.sellerRIN;
        data["complainantFirstName"] = this.complainantFirstName;
        data["complainantLastName"] = this.complainantLastName;
        data["complainantPhone"] = this.complainantPhone;
        data["reason"] = this.reason;
        data["response"] = this.response;
        if (Array.isArray(this.receipts)) {
            data["receipts"] = [];
            for (let item of this.receipts)
                data["receipts"].push(item.toJSON());
        }
        if (Array.isArray(this.submissions)) {
            data["submissions"] = [];
            for (let item of this.submissions)
                data["submissions"].push(item.toJSON());
        }
        if (Array.isArray(this.pos)) {
            data["pos"] = [];
            for (let item of this.pos)
                data["pos"].push(item.toJSON());
        }
        data["createdBy"] = this.createdBy;
        data["creationDatetimeUtc"] = this.creationDatetimeUtc ? this.creationDatetimeUtc.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modificationDatetimeUtc"] = this.modificationDatetimeUtc ? this.modificationDatetimeUtc.toISOString() : <any>undefined;
        return data;
    }

    clone(): ComplaintsResult {
        const json = this.toJSON();
        let result = new ComplaintsResult();
        result.init(json);
        return result;
    }
}

export interface IComplaintsResult {
    id?: number;
    reportId?: string | undefined;
    category?: string | undefined;
    type?: string | undefined;
    status?: string | undefined;
    title?: string | undefined;
    receiverRIN?: string | undefined;
    sellerRIN?: string | undefined;
    complainantFirstName?: string | undefined;
    complainantLastName?: string | undefined;
    complainantPhone?: string | undefined;
    reason?: string | undefined;
    response?: string | undefined;
    receipts?: ReceiptDto[] | undefined;
    submissions?: SubmissionDto[] | undefined;
    pos?: PosDto[] | undefined;
    createdBy?: string | undefined;
    creationDatetimeUtc?: Date;
    modifiedBy?: string | undefined;
    modificationDatetimeUtc?: Date | undefined;
}

export enum ComplaintStatuses {
    Pending = "Pending",
    Retracted = "Retracted",
    Resolved = "Resolved",
    Cancelled = "Cancelled",
}

export enum ComplaintTypes {
    TotalAmountNotMatched = "TotalAmountNotMatched",
}

export enum ETAComplaintStatuses {
    Cancel = "Cancel",
    Resolve = "Resolve",
}

export class FraudLookupsResult implements IFraudLookupsResult {
    types?: LookupDto[] | undefined;
    statuses?: LookupDto[] | undefined;
    nationalities?: LookupDto[] | undefined;
    header?: ResponseHeader;

    constructor(data?: IFraudLookupsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types!.push(LookupDto.fromJS(item));
            }
            if (Array.isArray(_data["statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["statuses"])
                    this.statuses!.push(LookupDto.fromJS(item));
            }
            if (Array.isArray(_data["nationalities"])) {
                this.nationalities = [] as any;
                for (let item of _data["nationalities"])
                    this.nationalities!.push(LookupDto.fromJS(item));
            }
            this.header = _data["header"] ? ResponseHeader.fromJS(_data["header"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FraudLookupsResult {
        data = typeof data === 'object' ? data : {};
        let result = new FraudLookupsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item.toJSON());
        }
        if (Array.isArray(this.statuses)) {
            data["statuses"] = [];
            for (let item of this.statuses)
                data["statuses"].push(item.toJSON());
        }
        if (Array.isArray(this.nationalities)) {
            data["nationalities"] = [];
            for (let item of this.nationalities)
                data["nationalities"].push(item.toJSON());
        }
        data["header"] = this.header ? this.header.toJSON() : <any>undefined;
        return data;
    }

    clone(): FraudLookupsResult {
        const json = this.toJSON();
        let result = new FraudLookupsResult();
        result.init(json);
        return result;
    }
}

export interface IFraudLookupsResult {
    types?: LookupDto[] | undefined;
    statuses?: LookupDto[] | undefined;
    nationalities?: LookupDto[] | undefined;
    header?: ResponseHeader;
}

export enum FraudsOrderByExpressions {
    CreationDatetime = "CreationDatetime",
    Type = "Type",
    Status = "Status",
}

export class FraudsResult implements IFraudsResult {
    id?: number;
    reportId?: string | undefined;
    contactedIssuer?: string | undefined;
    sellerRIN?: string | undefined;
    sellerName?: string | undefined;
    receiptUUID?: string | undefined;
    idNumber?: string | undefined;
    mobileNumber?: string | undefined;
    name?: string | undefined;
    sureName?: string | undefined;
    email?: string | undefined;
    type?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    attachmentName?: string | undefined;
    attachmentContent?: string | undefined;
    status?: string | undefined;
    reason?: string | undefined;
    response?: string | undefined;
    createdBy?: string | undefined;
    creationDatetimeUtc?: Date;
    modifiedBy?: string | undefined;
    modificationDatetimeUtc?: Date | undefined;

    constructor(data?: IFraudsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.reportId = _data["reportId"];
            this.contactedIssuer = _data["contactedIssuer"];
            this.sellerRIN = _data["sellerRIN"];
            this.sellerName = _data["sellerName"];
            this.receiptUUID = _data["receiptUUID"];
            this.idNumber = _data["idNumber"];
            this.mobileNumber = _data["mobileNumber"];
            this.name = _data["name"];
            this.sureName = _data["sureName"];
            this.email = _data["email"];
            this.type = _data["type"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.attachmentName = _data["attachmentName"];
            this.attachmentContent = _data["attachmentContent"];
            this.status = _data["status"];
            this.reason = _data["reason"];
            this.response = _data["response"];
            this.createdBy = _data["createdBy"];
            this.creationDatetimeUtc = _data["creationDatetimeUtc"] ? new Date(_data["creationDatetimeUtc"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modificationDatetimeUtc = _data["modificationDatetimeUtc"] ? new Date(_data["modificationDatetimeUtc"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): FraudsResult {
        data = typeof data === 'object' ? data : {};
        let result = new FraudsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reportId"] = this.reportId;
        data["contactedIssuer"] = this.contactedIssuer;
        data["sellerRIN"] = this.sellerRIN;
        data["sellerName"] = this.sellerName;
        data["receiptUUID"] = this.receiptUUID;
        data["idNumber"] = this.idNumber;
        data["mobileNumber"] = this.mobileNumber;
        data["name"] = this.name;
        data["sureName"] = this.sureName;
        data["email"] = this.email;
        data["type"] = this.type;
        data["title"] = this.title;
        data["description"] = this.description;
        data["attachmentName"] = this.attachmentName;
        data["attachmentContent"] = this.attachmentContent;
        data["status"] = this.status;
        data["reason"] = this.reason;
        data["response"] = this.response;
        data["createdBy"] = this.createdBy;
        data["creationDatetimeUtc"] = this.creationDatetimeUtc ? this.creationDatetimeUtc.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modificationDatetimeUtc"] = this.modificationDatetimeUtc ? this.modificationDatetimeUtc.toISOString() : <any>undefined;
        return data;
    }

    clone(): FraudsResult {
        const json = this.toJSON();
        let result = new FraudsResult();
        result.init(json);
        return result;
    }
}

export interface IFraudsResult {
    id?: number;
    reportId?: string | undefined;
    contactedIssuer?: string | undefined;
    sellerRIN?: string | undefined;
    sellerName?: string | undefined;
    receiptUUID?: string | undefined;
    idNumber?: string | undefined;
    mobileNumber?: string | undefined;
    name?: string | undefined;
    sureName?: string | undefined;
    email?: string | undefined;
    type?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    attachmentName?: string | undefined;
    attachmentContent?: string | undefined;
    status?: string | undefined;
    reason?: string | undefined;
    response?: string | undefined;
    createdBy?: string | undefined;
    creationDatetimeUtc?: Date;
    modifiedBy?: string | undefined;
    modificationDatetimeUtc?: Date | undefined;
}

export enum FraudStatuses {
    Pending = "Pending",
    Resolved = "Resolved",
    Cancelled = "Cancelled",
}

export enum FraudTypes {
    TotalAmountNotMatched = "TotalAmountNotMatched",
    Other = "Other",
}

export class GetComplaintDetails implements IGetComplaintDetails {
    id?: number;
    reportId?: string | undefined;
    category?: string | undefined;
    type?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    attachmentName?: string | undefined;
    attachmentContent?: string | undefined;
    receiverRIN?: string | undefined;
    sellerRIN?: string | undefined;
    complainantFirstName?: string | undefined;
    complainantLastName?: string | undefined;
    complainantEmail?: string | undefined;
    complainantPhone?: string | undefined;
    status?: string | undefined;
    reason?: string | undefined;
    response?: string | undefined;
    receipts?: ReceiptDto[] | undefined;
    submissions?: SubmissionDto[] | undefined;
    pos?: PosDto[] | undefined;
    createdBy?: string | undefined;
    creationDatetimeUtc?: Date;
    modifiedBy?: string | undefined;
    modificationDatetimeUtc?: Date | undefined;
    header?: ResponseHeader;

    constructor(data?: IGetComplaintDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.reportId = _data["reportId"];
            this.category = _data["category"];
            this.type = _data["type"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.attachmentName = _data["attachmentName"];
            this.attachmentContent = _data["attachmentContent"];
            this.receiverRIN = _data["receiverRIN"];
            this.sellerRIN = _data["sellerRIN"];
            this.complainantFirstName = _data["complainantFirstName"];
            this.complainantLastName = _data["complainantLastName"];
            this.complainantEmail = _data["complainantEmail"];
            this.complainantPhone = _data["complainantPhone"];
            this.status = _data["status"];
            this.reason = _data["reason"];
            this.response = _data["response"];
            if (Array.isArray(_data["receipts"])) {
                this.receipts = [] as any;
                for (let item of _data["receipts"])
                    this.receipts!.push(ReceiptDto.fromJS(item));
            }
            if (Array.isArray(_data["submissions"])) {
                this.submissions = [] as any;
                for (let item of _data["submissions"])
                    this.submissions!.push(SubmissionDto.fromJS(item));
            }
            if (Array.isArray(_data["pos"])) {
                this.pos = [] as any;
                for (let item of _data["pos"])
                    this.pos!.push(PosDto.fromJS(item));
            }
            this.createdBy = _data["createdBy"];
            this.creationDatetimeUtc = _data["creationDatetimeUtc"] ? new Date(_data["creationDatetimeUtc"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modificationDatetimeUtc = _data["modificationDatetimeUtc"] ? new Date(_data["modificationDatetimeUtc"].toString()) : <any>undefined;
            this.header = _data["header"] ? ResponseHeader.fromJS(_data["header"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetComplaintDetails {
        data = typeof data === 'object' ? data : {};
        let result = new GetComplaintDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reportId"] = this.reportId;
        data["category"] = this.category;
        data["type"] = this.type;
        data["title"] = this.title;
        data["description"] = this.description;
        data["attachmentName"] = this.attachmentName;
        data["attachmentContent"] = this.attachmentContent;
        data["receiverRIN"] = this.receiverRIN;
        data["sellerRIN"] = this.sellerRIN;
        data["complainantFirstName"] = this.complainantFirstName;
        data["complainantLastName"] = this.complainantLastName;
        data["complainantEmail"] = this.complainantEmail;
        data["complainantPhone"] = this.complainantPhone;
        data["status"] = this.status;
        data["reason"] = this.reason;
        data["response"] = this.response;
        if (Array.isArray(this.receipts)) {
            data["receipts"] = [];
            for (let item of this.receipts)
                data["receipts"].push(item.toJSON());
        }
        if (Array.isArray(this.submissions)) {
            data["submissions"] = [];
            for (let item of this.submissions)
                data["submissions"].push(item.toJSON());
        }
        if (Array.isArray(this.pos)) {
            data["pos"] = [];
            for (let item of this.pos)
                data["pos"].push(item.toJSON());
        }
        data["createdBy"] = this.createdBy;
        data["creationDatetimeUtc"] = this.creationDatetimeUtc ? this.creationDatetimeUtc.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modificationDatetimeUtc"] = this.modificationDatetimeUtc ? this.modificationDatetimeUtc.toISOString() : <any>undefined;
        data["header"] = this.header ? this.header.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetComplaintDetails {
        const json = this.toJSON();
        let result = new GetComplaintDetails();
        result.init(json);
        return result;
    }
}

export interface IGetComplaintDetails {
    id?: number;
    reportId?: string | undefined;
    category?: string | undefined;
    type?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    attachmentName?: string | undefined;
    attachmentContent?: string | undefined;
    receiverRIN?: string | undefined;
    sellerRIN?: string | undefined;
    complainantFirstName?: string | undefined;
    complainantLastName?: string | undefined;
    complainantEmail?: string | undefined;
    complainantPhone?: string | undefined;
    status?: string | undefined;
    reason?: string | undefined;
    response?: string | undefined;
    receipts?: ReceiptDto[] | undefined;
    submissions?: SubmissionDto[] | undefined;
    pos?: PosDto[] | undefined;
    createdBy?: string | undefined;
    creationDatetimeUtc?: Date;
    modifiedBy?: string | undefined;
    modificationDatetimeUtc?: Date | undefined;
    header?: ResponseHeader;
}

export class GetComplaintsResult implements IGetComplaintsResult {
    complaints?: ComplaintsResult[] | undefined;
    header?: ResponseHeader;

    constructor(data?: IGetComplaintsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["complaints"])) {
                this.complaints = [] as any;
                for (let item of _data["complaints"])
                    this.complaints!.push(ComplaintsResult.fromJS(item));
            }
            this.header = _data["header"] ? ResponseHeader.fromJS(_data["header"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetComplaintsResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetComplaintsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.complaints)) {
            data["complaints"] = [];
            for (let item of this.complaints)
                data["complaints"].push(item.toJSON());
        }
        data["header"] = this.header ? this.header.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetComplaintsResult {
        const json = this.toJSON();
        let result = new GetComplaintsResult();
        result.init(json);
        return result;
    }
}

export interface IGetComplaintsResult {
    complaints?: ComplaintsResult[] | undefined;
    header?: ResponseHeader;
}

export class GetFraudDetails implements IGetFraudDetails {
    id?: number;
    reportId?: string | undefined;
    contactedIssuer?: string | undefined;
    sellerRIN?: string | undefined;
    sellerName?: string | undefined;
    receiptUUID?: string | undefined;
    nationality?: string | undefined;
    idNumber?: string | undefined;
    mobileNumber?: string | undefined;
    name?: string | undefined;
    sureName?: string | undefined;
    email?: string | undefined;
    type?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    attachmentName?: string | undefined;
    attachmentContent?: string | undefined;
    status?: string | undefined;
    reason?: string | undefined;
    response?: string | undefined;
    createdBy?: string | undefined;
    creationDatetimeUtc?: Date;
    modifiedBy?: string | undefined;
    modificationDatetimeUtc?: Date | undefined;
    header?: ResponseHeader;

    constructor(data?: IGetFraudDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.reportId = _data["reportId"];
            this.contactedIssuer = _data["contactedIssuer"];
            this.sellerRIN = _data["sellerRIN"];
            this.sellerName = _data["sellerName"];
            this.receiptUUID = _data["receiptUUID"];
            this.nationality = _data["nationality"];
            this.idNumber = _data["idNumber"];
            this.mobileNumber = _data["mobileNumber"];
            this.name = _data["name"];
            this.sureName = _data["sureName"];
            this.email = _data["email"];
            this.type = _data["type"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.attachmentName = _data["attachmentName"];
            this.attachmentContent = _data["attachmentContent"];
            this.status = _data["status"];
            this.reason = _data["reason"];
            this.response = _data["response"];
            this.createdBy = _data["createdBy"];
            this.creationDatetimeUtc = _data["creationDatetimeUtc"] ? new Date(_data["creationDatetimeUtc"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modificationDatetimeUtc = _data["modificationDatetimeUtc"] ? new Date(_data["modificationDatetimeUtc"].toString()) : <any>undefined;
            this.header = _data["header"] ? ResponseHeader.fromJS(_data["header"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetFraudDetails {
        data = typeof data === 'object' ? data : {};
        let result = new GetFraudDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reportId"] = this.reportId;
        data["contactedIssuer"] = this.contactedIssuer;
        data["sellerRIN"] = this.sellerRIN;
        data["sellerName"] = this.sellerName;
        data["receiptUUID"] = this.receiptUUID;
        data["nationality"] = this.nationality;
        data["idNumber"] = this.idNumber;
        data["mobileNumber"] = this.mobileNumber;
        data["name"] = this.name;
        data["sureName"] = this.sureName;
        data["email"] = this.email;
        data["type"] = this.type;
        data["title"] = this.title;
        data["description"] = this.description;
        data["attachmentName"] = this.attachmentName;
        data["attachmentContent"] = this.attachmentContent;
        data["status"] = this.status;
        data["reason"] = this.reason;
        data["response"] = this.response;
        data["createdBy"] = this.createdBy;
        data["creationDatetimeUtc"] = this.creationDatetimeUtc ? this.creationDatetimeUtc.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modificationDatetimeUtc"] = this.modificationDatetimeUtc ? this.modificationDatetimeUtc.toISOString() : <any>undefined;
        data["header"] = this.header ? this.header.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetFraudDetails {
        const json = this.toJSON();
        let result = new GetFraudDetails();
        result.init(json);
        return result;
    }
}

export interface IGetFraudDetails {
    id?: number;
    reportId?: string | undefined;
    contactedIssuer?: string | undefined;
    sellerRIN?: string | undefined;
    sellerName?: string | undefined;
    receiptUUID?: string | undefined;
    nationality?: string | undefined;
    idNumber?: string | undefined;
    mobileNumber?: string | undefined;
    name?: string | undefined;
    sureName?: string | undefined;
    email?: string | undefined;
    type?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    attachmentName?: string | undefined;
    attachmentContent?: string | undefined;
    status?: string | undefined;
    reason?: string | undefined;
    response?: string | undefined;
    createdBy?: string | undefined;
    creationDatetimeUtc?: Date;
    modifiedBy?: string | undefined;
    modificationDatetimeUtc?: Date | undefined;
    header?: ResponseHeader;
}

export class GetFraudsResult implements IGetFraudsResult {
    complaints?: FraudsResult[] | undefined;
    header?: ResponseHeader;

    constructor(data?: IGetFraudsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["complaints"])) {
                this.complaints = [] as any;
                for (let item of _data["complaints"])
                    this.complaints!.push(FraudsResult.fromJS(item));
            }
            this.header = _data["header"] ? ResponseHeader.fromJS(_data["header"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetFraudsResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetFraudsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.complaints)) {
            data["complaints"] = [];
            for (let item of this.complaints)
                data["complaints"].push(item.toJSON());
        }
        data["header"] = this.header ? this.header.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetFraudsResult {
        const json = this.toJSON();
        let result = new GetFraudsResult();
        result.init(json);
        return result;
    }
}

export interface IGetFraudsResult {
    complaints?: FraudsResult[] | undefined;
    header?: ResponseHeader;
}

export class LookupDto implements ILookupDto {
    id?: number;
    code?: string | undefined;
    namePrimaryLang?: string | undefined;
    nameSecondaryLang?: string | undefined;

    constructor(data?: ILookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.namePrimaryLang = _data["namePrimaryLang"];
            this.nameSecondaryLang = _data["nameSecondaryLang"];
        }
    }

    static fromJS(data: any): LookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new LookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["namePrimaryLang"] = this.namePrimaryLang;
        data["nameSecondaryLang"] = this.nameSecondaryLang;
        return data;
    }

    clone(): LookupDto {
        const json = this.toJSON();
        let result = new LookupDto();
        result.init(json);
        return result;
    }
}

export interface ILookupDto {
    id?: number;
    code?: string | undefined;
    namePrimaryLang?: string | undefined;
    nameSecondaryLang?: string | undefined;
}

export enum Nationalities {
    Egyptian = "Egyptian",
    Foreigner = "Foreigner",
}

export enum OrderByDirections {
    Ascending = "Ascending",
    Descending = "Descending",
}

export class PosDto implements IPosDto {
    serialNumber?: string | undefined;
    name?: string | undefined;

    constructor(data?: IPosDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serialNumber = _data["serialNumber"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): PosDto {
        data = typeof data === 'object' ? data : {};
        let result = new PosDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serialNumber"] = this.serialNumber;
        data["name"] = this.name;
        return data;
    }

    clone(): PosDto {
        const json = this.toJSON();
        let result = new PosDto();
        result.init(json);
        return result;
    }
}

export interface IPosDto {
    serialNumber?: string | undefined;
    name?: string | undefined;
}

export class ReceiptDto implements IReceiptDto {
    uuid?: string | undefined;
    internalId?: string | undefined;

    constructor(data?: IReceiptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uuid = _data["uuid"];
            this.internalId = _data["internalId"];
        }
    }

    static fromJS(data: any): ReceiptDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uuid"] = this.uuid;
        data["internalId"] = this.internalId;
        return data;
    }

    clone(): ReceiptDto {
        const json = this.toJSON();
        let result = new ReceiptDto();
        result.init(json);
        return result;
    }
}

export interface IReceiptDto {
    uuid?: string | undefined;
    internalId?: string | undefined;
}

export enum ResponseCode {
    Success = "Success",
    SystemError = "SystemError",
    ValidationError = "ValidationError",
    NotFound = "NotFound",
    InvalidInput = "InvalidInput",
    AuthenticationError = "AuthenticationError",
    AccessLocked = "AccessLocked",
    AccessDenied = "AccessDenied",
}

export class ResponseHeader implements IResponseHeader {
    statusCode?: ResponseCode;
    readonly code?: string | undefined;
    message?: string | undefined;
    target?: string | undefined;
    details?: ValidationError[] | undefined;
    correlationId?: string | undefined;
    requestTime?: Date | undefined;
    readonly responseProcessingTimeInTicks?: number | undefined;

    constructor(data?: IResponseHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            (<any>this).code = _data["code"];
            this.message = _data["message"];
            this.target = _data["target"];
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(ValidationError.fromJS(item));
            }
            this.correlationId = _data["correlationId"];
            this.requestTime = _data["requestTime"] ? new Date(_data["requestTime"].toString()) : <any>undefined;
            (<any>this).responseProcessingTimeInTicks = _data["responseProcessingTimeInTicks"];
        }
    }

    static fromJS(data: any): ResponseHeader {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseHeader();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["code"] = this.code;
        data["message"] = this.message;
        data["target"] = this.target;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        data["correlationId"] = this.correlationId;
        data["requestTime"] = this.requestTime ? this.requestTime.toISOString() : <any>undefined;
        data["responseProcessingTimeInTicks"] = this.responseProcessingTimeInTicks;
        return data;
    }

    clone(): ResponseHeader {
        const json = this.toJSON();
        let result = new ResponseHeader();
        result.init(json);
        return result;
    }
}

export interface IResponseHeader {
    statusCode?: ResponseCode;
    code?: string | undefined;
    message?: string | undefined;
    target?: string | undefined;
    details?: ValidationError[] | undefined;
    correlationId?: string | undefined;
    requestTime?: Date | undefined;
    responseProcessingTimeInTicks?: number | undefined;
}

export class SubmissionDto implements ISubmissionDto {
    uuid?: string | undefined;

    constructor(data?: ISubmissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uuid = _data["uuid"];
        }
    }

    static fromJS(data: any): SubmissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubmissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uuid"] = this.uuid;
        return data;
    }

    clone(): SubmissionDto {
        const json = this.toJSON();
        let result = new SubmissionDto();
        result.init(json);
        return result;
    }
}

export interface ISubmissionDto {
    uuid?: string | undefined;
}

export class SubmitComplaintRequest implements ISubmitComplaintRequest {
    category?: ComplaintCategories;
    type?: ComplaintTypes;
    title?: string | undefined;
    description?: string | undefined;
    attachmentExtension?: AttachmentExtenssions;
    attachmentName?: string | undefined;
    attachmentContent?: string | undefined;
    receiverRIN?: string | undefined;
    sellerRIN?: string | undefined;
    receipts?: ReceiptDto[] | undefined;
    submissions?: SubmissionDto[] | undefined;
    pos?: PosDto[] | undefined;
    complainantFirstName?: string | undefined;
    complainantLastName?: string | undefined;
    complainantEmail?: string | undefined;
    complainantPhone?: string | undefined;

    constructor(data?: ISubmitComplaintRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
            this.type = _data["type"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.attachmentExtension = _data["attachmentExtension"];
            this.attachmentName = _data["attachmentName"];
            this.attachmentContent = _data["attachmentContent"];
            this.receiverRIN = _data["receiverRIN"];
            this.sellerRIN = _data["sellerRIN"];
            if (Array.isArray(_data["receipts"])) {
                this.receipts = [] as any;
                for (let item of _data["receipts"])
                    this.receipts!.push(ReceiptDto.fromJS(item));
            }
            if (Array.isArray(_data["submissions"])) {
                this.submissions = [] as any;
                for (let item of _data["submissions"])
                    this.submissions!.push(SubmissionDto.fromJS(item));
            }
            if (Array.isArray(_data["pos"])) {
                this.pos = [] as any;
                for (let item of _data["pos"])
                    this.pos!.push(PosDto.fromJS(item));
            }
            this.complainantFirstName = _data["complainantFirstName"];
            this.complainantLastName = _data["complainantLastName"];
            this.complainantEmail = _data["complainantEmail"];
            this.complainantPhone = _data["complainantPhone"];
        }
    }

    static fromJS(data: any): SubmitComplaintRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitComplaintRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["type"] = this.type;
        data["title"] = this.title;
        data["description"] = this.description;
        data["attachmentExtension"] = this.attachmentExtension;
        data["attachmentName"] = this.attachmentName;
        data["attachmentContent"] = this.attachmentContent;
        data["receiverRIN"] = this.receiverRIN;
        data["sellerRIN"] = this.sellerRIN;
        if (Array.isArray(this.receipts)) {
            data["receipts"] = [];
            for (let item of this.receipts)
                data["receipts"].push(item.toJSON());
        }
        if (Array.isArray(this.submissions)) {
            data["submissions"] = [];
            for (let item of this.submissions)
                data["submissions"].push(item.toJSON());
        }
        if (Array.isArray(this.pos)) {
            data["pos"] = [];
            for (let item of this.pos)
                data["pos"].push(item.toJSON());
        }
        data["complainantFirstName"] = this.complainantFirstName;
        data["complainantLastName"] = this.complainantLastName;
        data["complainantEmail"] = this.complainantEmail;
        data["complainantPhone"] = this.complainantPhone;
        return data;
    }

    clone(): SubmitComplaintRequest {
        const json = this.toJSON();
        let result = new SubmitComplaintRequest();
        result.init(json);
        return result;
    }
}

export interface ISubmitComplaintRequest {
    category?: ComplaintCategories;
    type?: ComplaintTypes;
    title?: string | undefined;
    description?: string | undefined;
    attachmentExtension?: AttachmentExtenssions;
    attachmentName?: string | undefined;
    attachmentContent?: string | undefined;
    receiverRIN?: string | undefined;
    sellerRIN?: string | undefined;
    receipts?: ReceiptDto[] | undefined;
    submissions?: SubmissionDto[] | undefined;
    pos?: PosDto[] | undefined;
    complainantFirstName?: string | undefined;
    complainantLastName?: string | undefined;
    complainantEmail?: string | undefined;
    complainantPhone?: string | undefined;
}

export class SubmitComplaintResult implements ISubmitComplaintResult {
    id?: number;
    reportId?: string | undefined;
    header?: ResponseHeader;

    constructor(data?: ISubmitComplaintResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.reportId = _data["reportId"];
            this.header = _data["header"] ? ResponseHeader.fromJS(_data["header"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SubmitComplaintResult {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitComplaintResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reportId"] = this.reportId;
        data["header"] = this.header ? this.header.toJSON() : <any>undefined;
        return data;
    }

    clone(): SubmitComplaintResult {
        const json = this.toJSON();
        let result = new SubmitComplaintResult();
        result.init(json);
        return result;
    }
}

export interface ISubmitComplaintResult {
    id?: number;
    reportId?: string | undefined;
    header?: ResponseHeader;
}

export class SubmitFraudRequest implements ISubmitFraudRequest {
    contactedIssuer?: string | undefined;
    sellerRIN?: string | undefined;
    sellerName?: string | undefined;
    receiptUUID?: string | undefined;
    nationalityId?: Nationalities;
    idNumber?: string | undefined;
    mobileNumber?: string | undefined;
    name?: string | undefined;
    sureName?: string | undefined;
    email?: string | undefined;
    typeId?: FraudTypes;
    title?: string | undefined;
    description?: string | undefined;
    attachmentExtenssion?: AttachmentExtenssions;
    attachmentName?: string | undefined;
    attachmentContent?: string | undefined;

    constructor(data?: ISubmitFraudRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactedIssuer = _data["contactedIssuer"];
            this.sellerRIN = _data["sellerRIN"];
            this.sellerName = _data["sellerName"];
            this.receiptUUID = _data["receiptUUID"];
            this.nationalityId = _data["nationalityId"];
            this.idNumber = _data["idNumber"];
            this.mobileNumber = _data["mobileNumber"];
            this.name = _data["name"];
            this.sureName = _data["sureName"];
            this.email = _data["email"];
            this.typeId = _data["typeId"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.attachmentExtenssion = _data["attachmentExtenssion"];
            this.attachmentName = _data["attachmentName"];
            this.attachmentContent = _data["attachmentContent"];
        }
    }

    static fromJS(data: any): SubmitFraudRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitFraudRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactedIssuer"] = this.contactedIssuer;
        data["sellerRIN"] = this.sellerRIN;
        data["sellerName"] = this.sellerName;
        data["receiptUUID"] = this.receiptUUID;
        data["nationalityId"] = this.nationalityId;
        data["idNumber"] = this.idNumber;
        data["mobileNumber"] = this.mobileNumber;
        data["name"] = this.name;
        data["sureName"] = this.sureName;
        data["email"] = this.email;
        data["typeId"] = this.typeId;
        data["title"] = this.title;
        data["description"] = this.description;
        data["attachmentExtenssion"] = this.attachmentExtenssion;
        data["attachmentName"] = this.attachmentName;
        data["attachmentContent"] = this.attachmentContent;
        return data;
    }

    clone(): SubmitFraudRequest {
        const json = this.toJSON();
        let result = new SubmitFraudRequest();
        result.init(json);
        return result;
    }
}

export interface ISubmitFraudRequest {
    contactedIssuer?: string | undefined;
    sellerRIN?: string | undefined;
    sellerName?: string | undefined;
    receiptUUID?: string | undefined;
    nationalityId?: Nationalities;
    idNumber?: string | undefined;
    mobileNumber?: string | undefined;
    name?: string | undefined;
    sureName?: string | undefined;
    email?: string | undefined;
    typeId?: FraudTypes;
    title?: string | undefined;
    description?: string | undefined;
    attachmentExtenssion?: AttachmentExtenssions;
    attachmentName?: string | undefined;
    attachmentContent?: string | undefined;
}

export class SubmitFraudResult implements ISubmitFraudResult {
    id?: number;
    reportId?: string | undefined;
    header?: ResponseHeader;

    constructor(data?: ISubmitFraudResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.reportId = _data["reportId"];
            this.header = _data["header"] ? ResponseHeader.fromJS(_data["header"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SubmitFraudResult {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitFraudResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reportId"] = this.reportId;
        data["header"] = this.header ? this.header.toJSON() : <any>undefined;
        return data;
    }

    clone(): SubmitFraudResult {
        const json = this.toJSON();
        let result = new SubmitFraudResult();
        result.init(json);
        return result;
    }
}

export interface ISubmitFraudResult {
    id?: number;
    reportId?: string | undefined;
    header?: ResponseHeader;
}

export class UpdateComplaintRequest implements IUpdateComplaintRequest {
    status?: ETAComplaintStatuses;
    reason?: string | undefined;
    response?: string | undefined;

    constructor(data?: IUpdateComplaintRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.reason = _data["reason"];
            this.response = _data["response"];
        }
    }

    static fromJS(data: any): UpdateComplaintRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateComplaintRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["reason"] = this.reason;
        data["response"] = this.response;
        return data;
    }

    clone(): UpdateComplaintRequest {
        const json = this.toJSON();
        let result = new UpdateComplaintRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateComplaintRequest {
    status?: ETAComplaintStatuses;
    reason?: string | undefined;
    response?: string | undefined;
}

export class UpdateComplaintResult implements IUpdateComplaintResult {
    updated?: boolean;
    header?: ResponseHeader;

    constructor(data?: IUpdateComplaintResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.updated = _data["updated"];
            this.header = _data["header"] ? ResponseHeader.fromJS(_data["header"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateComplaintResult {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateComplaintResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updated"] = this.updated;
        data["header"] = this.header ? this.header.toJSON() : <any>undefined;
        return data;
    }

    clone(): UpdateComplaintResult {
        const json = this.toJSON();
        let result = new UpdateComplaintResult();
        result.init(json);
        return result;
    }
}

export interface IUpdateComplaintResult {
    updated?: boolean;
    header?: ResponseHeader;
}

export class UpdateFraudRequest implements IUpdateFraudRequest {
    status?: ETAComplaintStatuses;
    reason?: string | undefined;
    response?: string | undefined;

    constructor(data?: IUpdateFraudRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.reason = _data["reason"];
            this.response = _data["response"];
        }
    }

    static fromJS(data: any): UpdateFraudRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFraudRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["reason"] = this.reason;
        data["response"] = this.response;
        return data;
    }

    clone(): UpdateFraudRequest {
        const json = this.toJSON();
        let result = new UpdateFraudRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateFraudRequest {
    status?: ETAComplaintStatuses;
    reason?: string | undefined;
    response?: string | undefined;
}

export class UpdateFraudResult implements IUpdateFraudResult {
    updated?: boolean;
    header?: ResponseHeader;

    constructor(data?: IUpdateFraudResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.updated = _data["updated"];
            this.header = _data["header"] ? ResponseHeader.fromJS(_data["header"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateFraudResult {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFraudResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updated"] = this.updated;
        data["header"] = this.header ? this.header.toJSON() : <any>undefined;
        return data;
    }

    clone(): UpdateFraudResult {
        const json = this.toJSON();
        let result = new UpdateFraudResult();
        result.init(json);
        return result;
    }
}

export interface IUpdateFraudResult {
    updated?: boolean;
    header?: ResponseHeader;
}

export class UpdateStatusRequest implements IUpdateStatusRequest {
    status?: UserComplaintStatuses;
    reason?: string | undefined;

    constructor(data?: IUpdateStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): UpdateStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["reason"] = this.reason;
        return data;
    }

    clone(): UpdateStatusRequest {
        const json = this.toJSON();
        let result = new UpdateStatusRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateStatusRequest {
    status?: UserComplaintStatuses;
    reason?: string | undefined;
}

export class UpdateStatusResult implements IUpdateStatusResult {
    updated?: boolean;
    header?: ResponseHeader;

    constructor(data?: IUpdateStatusResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.updated = _data["updated"];
            this.header = _data["header"] ? ResponseHeader.fromJS(_data["header"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateStatusResult {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStatusResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updated"] = this.updated;
        data["header"] = this.header ? this.header.toJSON() : <any>undefined;
        return data;
    }

    clone(): UpdateStatusResult {
        const json = this.toJSON();
        let result = new UpdateStatusResult();
        result.init(json);
        return result;
    }
}

export interface IUpdateStatusResult {
    updated?: boolean;
    header?: ResponseHeader;
}

export enum UserComplaintStatuses {
    Retract = "Retract",
}

export class ValidationError implements IValidationError {
    code?: string | undefined;
    target?: string | undefined;
    message?: string | undefined;

    constructor(data?: IValidationError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.target = _data["target"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ValidationError {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["target"] = this.target;
        data["message"] = this.message;
        return data;
    }

    clone(): ValidationError {
        const json = this.toJSON();
        let result = new ValidationError();
        result.init(json);
        return result;
    }
}

export interface IValidationError {
    code?: string | undefined;
    target?: string | undefined;
    message?: string | undefined;
}

export class ViewFraudResponse implements IViewFraudResponse {
    id?: number;
    reportId?: string | undefined;
    contactedIssuer?: string | undefined;
    sellerRIN?: string | undefined;
    sellerName?: string | undefined;
    receiptUUID?: string | undefined;
    nationality?: string | undefined;
    idNumber?: string | undefined;
    mobileNumber?: string | undefined;
    name?: string | undefined;
    sureName?: string | undefined;
    email?: string | undefined;
    type?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    attachmentName?: string | undefined;
    attachmentContent?: string | undefined;
    status?: string | undefined;
    reason?: string | undefined;
    response?: string | undefined;
    createdBy?: string | undefined;
    creationDatetimeUtc?: Date;
    modifiedBy?: string | undefined;
    modificationDatetimeUtc?: Date | undefined;
    header?: ResponseHeader;

    constructor(data?: IViewFraudResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.reportId = _data["reportId"];
            this.contactedIssuer = _data["contactedIssuer"];
            this.sellerRIN = _data["sellerRIN"];
            this.sellerName = _data["sellerName"];
            this.receiptUUID = _data["receiptUUID"];
            this.nationality = _data["nationality"];
            this.idNumber = _data["idNumber"];
            this.mobileNumber = _data["mobileNumber"];
            this.name = _data["name"];
            this.sureName = _data["sureName"];
            this.email = _data["email"];
            this.type = _data["type"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.attachmentName = _data["attachmentName"];
            this.attachmentContent = _data["attachmentContent"];
            this.status = _data["status"];
            this.reason = _data["reason"];
            this.response = _data["response"];
            this.createdBy = _data["createdBy"];
            this.creationDatetimeUtc = _data["creationDatetimeUtc"] ? new Date(_data["creationDatetimeUtc"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modificationDatetimeUtc = _data["modificationDatetimeUtc"] ? new Date(_data["modificationDatetimeUtc"].toString()) : <any>undefined;
            this.header = _data["header"] ? ResponseHeader.fromJS(_data["header"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ViewFraudResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ViewFraudResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reportId"] = this.reportId;
        data["contactedIssuer"] = this.contactedIssuer;
        data["sellerRIN"] = this.sellerRIN;
        data["sellerName"] = this.sellerName;
        data["receiptUUID"] = this.receiptUUID;
        data["nationality"] = this.nationality;
        data["idNumber"] = this.idNumber;
        data["mobileNumber"] = this.mobileNumber;
        data["name"] = this.name;
        data["sureName"] = this.sureName;
        data["email"] = this.email;
        data["type"] = this.type;
        data["title"] = this.title;
        data["description"] = this.description;
        data["attachmentName"] = this.attachmentName;
        data["attachmentContent"] = this.attachmentContent;
        data["status"] = this.status;
        data["reason"] = this.reason;
        data["response"] = this.response;
        data["createdBy"] = this.createdBy;
        data["creationDatetimeUtc"] = this.creationDatetimeUtc ? this.creationDatetimeUtc.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modificationDatetimeUtc"] = this.modificationDatetimeUtc ? this.modificationDatetimeUtc.toISOString() : <any>undefined;
        data["header"] = this.header ? this.header.toJSON() : <any>undefined;
        return data;
    }

    clone(): ViewFraudResponse {
        const json = this.toJSON();
        let result = new ViewFraudResponse();
        result.init(json);
        return result;
    }
}

export interface IViewFraudResponse {
    id?: number;
    reportId?: string | undefined;
    contactedIssuer?: string | undefined;
    sellerRIN?: string | undefined;
    sellerName?: string | undefined;
    receiptUUID?: string | undefined;
    nationality?: string | undefined;
    idNumber?: string | undefined;
    mobileNumber?: string | undefined;
    name?: string | undefined;
    sureName?: string | undefined;
    email?: string | undefined;
    type?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    attachmentName?: string | undefined;
    attachmentContent?: string | undefined;
    status?: string | undefined;
    reason?: string | undefined;
    response?: string | undefined;
    createdBy?: string | undefined;
    creationDatetimeUtc?: Date;
    modifiedBy?: string | undefined;
    modificationDatetimeUtc?: Date | undefined;
    header?: ResponseHeader;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}